module.exports = __webpack_public_path__ + "img/kiatros-logo.3dd71666.svg";